import { CE_SCREEN_CLOSE } from "@js/actions/studio/screens.js";

export const CE_VIEW_RENDERED_PREVIEW_OPEN = "CE_VIEW_RENDERED_PREVIEW_OPEN";
export const ceScreenViewRenderedPreviewOpen = (clientContentID) => ({
  type: CE_VIEW_RENDERED_PREVIEW_OPEN,
  client_content_id: clientContentID,
});

export const ceScreenViewRenderedPreviewCancel = () => ({
  type: CE_SCREEN_CLOSE,
});
